import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, first, of, tap } from 'rxjs';
import { ColmecWorkOrder } from '../components/working-order/colmec-working-order-wrapper/colmec-working-order-wrapper.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecWorkingOrderService {
  private workOrdersSubjectMap: { [s: string]: BehaviorSubject<ColmecWorkOrder[]> } = {};
  protected baseUrl: string = 'json/work-orders';

  constructor(protected http: HttpClient) { }

  public getListWorkingOrders(isAdminOrSales: boolean = false, partnerId?: string): Observable<ColmecWorkOrder[]> {
    if (!this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId]) {
      this.updateWorkOrdersSubject(isAdminOrSales, partnerId);
    }
    return this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId].asObservable();
  }

  protected updateWorkOrdersSubject(isAdminOrSales: boolean = false, partnerId?: string): void {
    if (!this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId]) {
      this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId] = new BehaviorSubject<ColmecWorkOrder[]>([]);
    }

    if (isAdminOrSales) {
      this.getAllWorkingOrders(true)
        .pipe(first())
        .subscribe(res => {
          this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId].next(res);
        });
    } else if (!isAdminOrSales && !!partnerId) {
      this.getWorkingOrdersByPartnerId(partnerId, true)
        .pipe(first())
        .subscribe(res => {
          this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId].next(res);
        });
    } else {
      this.workOrdersSubjectMap[isAdminOrSales ? 'admin_or_sales' : partnerId].next([]);
    }
  }

  public getAllWorkingOrders(noCache: boolean = false): Observable<ColmecWorkOrder[]> {
    const url: string = `${this.baseUrl}`;
    const headers = {
      maxAge: noCache ? '-1' : '300'
    };
    return this.http.get<ColmecWorkOrder[]>(url, { headers });
  }

  public getWorkingOrder(id: string, noCache: boolean = false): Observable<ColmecWorkOrder> {
    const url: string = `${this.baseUrl}/${id}`;
    const headers = {
      maxAge: noCache ? '-1' : '300'
    };
    return this.http.get<ColmecWorkOrder>(url, { headers });
  }

  public getWorkingOrdersByPartnerId(partnerId: string, noCache: boolean = false): Observable<ColmecWorkOrder[]> {
    const url: string = `${this.baseUrl}/by-partner-id/${partnerId}`;
    const headers = {
      maxAge: noCache ? '-1' : '300'
    };
    return this.http.get<ColmecWorkOrder[]>(url, { headers });
  }

  public getWorkingOrdersByCustomerId(customerId: string, noCache: boolean = false): Observable<ColmecWorkOrder[]> {
    const url: string = `${this.baseUrl}/by-customer-id/${customerId}`;
    const headers = {
      maxAge: noCache ? '-1' : '300'
    };
    return this.http.get<ColmecWorkOrder[]>(url, { headers });
  }

  public updateWorkingOrder(workOrder: ColmecWorkOrder, isAdminOrSales: boolean = false): Observable<any> {
    const partnerId: string = workOrder?.agreementId?.split('@')?.[1]?.split('_')?.[0] || '';
    const url: string = `${this.baseUrl}/${workOrder.id}?ignoreTirePolicy=true`;
    return this.http
      .put<ColmecWorkOrder>(url, workOrder)
      .pipe(tap(_ => this.updateWorkOrdersSubject(isAdminOrSales, partnerId)));
  }
}
